<div class="container my-3">
  <div class="d-flex flex-wrap">
    <div class="category-item d-none d-sm-block" *ngFor="let i of categoriesItems"></div>
  </div>

  <div class="category-item d-sm-none"></div>
</div>

<div class="container mt-3 mb-sm-max-3">
  <div class="d-flex flex-wrap">
    <div class="filter-item d-none d-md-block" *ngFor="let i of categoriesItems"></div>
  </div>

  <div class="filter-item d-md-none"></div>
</div>
